/**
 * REVIEWS.io Lazy-Load Performance-Patch
 * --------------------------------------
 * Zweck: Reduziert den Initial-Page-Load der Produktseite, indem
 * der REVIEWS.io Polaris- und UGC-App-Block-Bereich erst beim Scrollen
 * vollständig gerendert wird und Bilder per native lazy-loading kommen.
 *
 * Wirkungsweise:
 *  1) content-visibility:auto auf Reviews.io-Container → kein Initial-Render unter dem Fold
 *  2) MutationObserver: jede dynamisch injizierte <img> bekommt loading="lazy" + decoding="async"
 *  3) Observer-Auto-Disconnect nach 15s — Polaris ist dann längst fertig
 *
 * Nicht-invasiv: App-Blocks bleiben unverändert (Reviews.io-App-Updates greifen weiter).
 *
 * Eingeführt: 2026-05-21 (Task #13 PERF — Reviews.io Lazy-Load)
 * Quelle: /60_SEO/20_Audits/performance_audit_2026-05-12.md (Hebel A, -3 bis -4s versprochen)
 */
(function () {
  'use strict';

  // Selektoren für Reviews.io App-Block-Container im Shopify-Theme
  var SELECTORS = [
    '[id*="reviews_io_reviewsio_polaris"]',
    '[id*="reviews_io_reviewsio_ugc"]',
    '[id*="reviews_io_reviewsio_card_carousel"]',
    '[class*="reviewsio-polaris"]',
    '[class*="reviewsio-ugc"]',
    '[class*="ruk_polaris"]',
    'reviewsio-product-reviews',
    'reviewsio-carousel-inline'
  ];

  function applyContainerLazy(el) {
    if (!el || el.dataset.reviewsioLazyApplied === 'true') return;
    // content-visibility:auto = Browser rendert subtree erst wenn near-viewport
    el.style.setProperty('content-visibility', 'auto');
    // Reserve-Höhe, damit der Layout nicht springt (CLS-Schutz)
    el.style.setProperty('contain-intrinsic-size', '0 1200px');
    el.dataset.reviewsioLazyApplied = 'true';
  }

  function forceLazyOnImages(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.reviewsioLazyForced === 'true') continue;
      // Nur setzen wenn nicht schon explizit auf "eager" forciert
      var current = img.getAttribute('loading');
      if (current !== 'eager') {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      }
      img.dataset.reviewsioLazyForced = 'true';
    }
  }

  function scan() {
    for (var i = 0; i < SELECTORS.length; i++) {
      try {
        var found = document.querySelectorAll(SELECTORS[i]);
        for (var j = 0; j < found.length; j++) {
          applyContainerLazy(found[j]);
          forceLazyOnImages(found[j]);
        }
      } catch (e) {
        // ungültiger Selector → überspringen
      }
    }
  }

  function startObserver() {
    if (!('MutationObserver' in window)) return;
    if (!document.body) return;
    var observer = new MutationObserver(function (mutations) {
      var rescanNeeded = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          rescanNeeded = true;
          break;
        }
      }
      if (rescanNeeded) scan();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Polaris/UGC ist nach ~10s sicher fertig — Observer ressourcenschonend abschalten
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  function init() {
    scan();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
